import {
  CheckCircleFilled,
  CloseCircleFilled,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { ColumnsType } from "antd/es/table";
import { t } from "i18next";
import { PaginationPayload } from "../../../types";
import { FilterItem, FilterItemType } from "../../filters/filters.types";
import {
  PeriodicReport,
  PeriodicReportListFilterPayload,
} from "./periodicReports.types";

export const PERIODIC_REPORT_LIST_INITIAL_FILTERS: PeriodicReportListFilterPayload =
  {
    drustvoPIB: null,
    periodId: null,
    sistemskiGenerisan: null,
    pageNumber: 1,
    pageSize: 10,
  };

export const PERIODIC_REPORT_LIST_INITIAL_PAGINATION: PaginationPayload = {
  pageNumber: 1,
  pageSize: 10,
};

export const getPeriodicReportTableColumns = ({
  onDetailClickHandler,
}: {
  onDetailClickHandler: (periodicReport: PeriodicReport) => void;
}) => {
  return [
    {
      title: t("AKCIZNE_MARKICE.PERIOD"),
      dataIndex: "period",
    },
    {
      title: t("TABLES.DRUSTVO_NAZIV"),
      dataIndex: "drustvoNaziv",
    },
    {
      title: t("TABLES.DRUSTVO_PIB"),
      dataIndex: "drustvoPib",
    },
    {
      title: t("TABLES.GENERISAO_SISTEM"),
      render: (record: PeriodicReport) => {
        return record.generisaoSistem ? (
          <CheckCircleFilled style={{ color: "#0cad65", fontSize: 20 }} />
        ) : (
          <CloseCircleFilled style={{ color: "#ed7373", fontSize: 20 }} />
        );
      },
    },
    {
      title: t("TRACK.DETALJI"),
      fixed: "right",
      align: "start",
      width: "150px",
      render: (record: PeriodicReport) => {
        return (
          <Button
            type="primary"
            icon={
              <UnorderedListOutlined
                onClick={() => {
                  onDetailClickHandler(record);
                }}
              />
            }
            block
          >
            {t("TRACK.DETALJI")}
          </Button>
        );
      },
    },
  ] as ColumnsType<PeriodicReport>;
};

export const getPeriodicReportListFilterItems = ({
  isLoading,
  isDisabled,
  periodList,
}: {
  isLoading?: boolean;
  isDisabled?: boolean;
  periodList?: Array<DefaultOptionType>;
}): Array<FilterItem<PeriodicReportListFilterPayload>> => {
  return [
    {
      fieldName: "drustvoPIB",
      type: FilterItemType.TEXT,
      props: {
        placeholder: t("TRACK.PIB_DRUSTVA"),
        allowClear: true,
      },
    },
    {
      fieldName: "sistemskiGenerisan",
      type: FilterItemType.SELECT,
      props: {
        placeholder: t("TABLES.GENERISAO_SISTEM"),
        options: [
          { label: t("TABLES.DA"), value: true },
          { label: t("TABLES.NE"), value: false },
        ] as any,
      },
    },
    {
      fieldName: "periodId",
      type: FilterItemType.SELECT,
      props: {
        placeholder: t("AKCIZNE_MARKICE.PERIOD"),
        loading: isLoading,
        options: periodList,
        disabled: isDisabled,
        value: periodList?.[0]?.value,
      },
    },
  ];
};
